export const styles = theme => ({
  root: {
    padding: theme.spacing(4, 6),
    position: 'relative',
    overflowY: 'unset',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 2),
    },
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(-2),
    zIndex: 999,
    minWidth: 0,
    width: 40,
  },

  title: {
    textAlign: 'center',
    color: theme.palette.primary.dark,
  },

  description: {
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 300,
  },

  divider: {
    margin: theme.spacing(3, 0),
  },

  contentRoot: {
    flex: '1 1 auto',
    padding: 8,
    overflowY: 'auto',
    webkitOverflowScrolling: 'touch',
  },

  label: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },

  lookupContent: {
    backgroundColor: '#eee',
    padding: theme.spacing(0, 3),
  },

  dialogActions: {
    paddingTop: theme.spacing(3),
  },

  actionButton: {
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
    height: 50,
    boxShadow: 'none',
  },

  secondaryActionButton: {
    width: '100%',
    color: theme.palette.primary.dark,
    height: 50,
  },
})
